import { IsiDtoPlRacBandeauRequest, IsiDtoPlRacBandeauResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlRacBandeau";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlRacBandeau extends IsiPresentationLogic {

    constructor() {
        super("IsiPlRacBandeauHandler");
    }

    /**
     * Traitement pour récupérer le menu
     * */
    public async racBandeau(racName: string, racType: string, key: number, consKey: number):Promise<string> {
        const params = IsiDtoPlRacBandeauRequest.fromJS({
            racName: racName,
            racType: racType,
            key: key,
            consKey: consKey,
            response: IsiDtoPlRacBandeauResponse.fromJS({})
        });

        const result: IIsiUIFlowResultGeneric<IsiDtoPlRacBandeauRequest> = await this.ajaxWithErrorHandling("RacBandeau", params, true);

        return result?.reponse?.response?.result.getMenu;
    }

}